import React, { ReactNode } from 'react';

import { Button } from '@mui/material';

import { ControlBox, ControlBoxProps } from '../atoms/control-box';

type Props = {
  buttonLabel: ReactNode;
  onClick: () => void;
} & ControlBoxProps;

export const ButtonBox = ({ buttonLabel, ...props }: Props) => {
  return (
    <ControlBox
      control={<Button variant="contained">{buttonLabel}</Button>}
      {...props}
    />
  );
};
